export default function PHP_POST() {
  return (
    <div>
      <h1>PHP_POST</h1>
    </div>
  );
}
